module.exports = __webpack_public_path__ + "img/car_shina2_29.e3e8b159.jpg";